import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { getBidProposalDetail } from '../../api/constlink';
import BidProposalDetailComponent from '../../components/bid-chances/BidProposalDetailComponent';
import { RootState } from '../../modules';
import { BidProposal } from '../../modules/bid-chances';
interface BidProposalDetailContainerProps {
  enterpriseId: string;
  bidChanceId: string;
  bidProposalId: string;
}
function BidProposalDetailContainer({
  match,
  history,
}: RouteComponentProps<BidProposalDetailContainerProps>) {
  const { enterpriseId, bidChanceId, bidProposalId } = match.params;
  const [bidProposal, setBidProposal] = useState<BidProposal>();
  const [projectName, setProjectName] = useState<string>();
  const bidChance = useSelector(
    (state: RootState) => state.bidChances.bidChance.data,
  );
  const project = useSelector(
    (state: RootState) => state.projects.project.data,
  );

  useEffect(() => {
    const _getBidProposalDetail = async () => {
      const _bidProposal = await getBidProposalDetail({
        enterpriseId,
        bidChanceId,
        bidProposalId,
      });
      setBidProposal(_bidProposal);
    };
    _getBidProposalDetail();
  }, [enterpriseId, bidChanceId, bidProposalId]);

  useEffect(() => {
    if (bidChanceId) {
      setProjectName(bidChance?.bidder.bidPackage!.project!.name);
    } else {
      setProjectName(project?.name);
    }
  }, [bidChanceId, project, bidChance]);

  return (
    <>
      {bidProposal && projectName && (
        <BidProposalDetailComponent
          bidProposal={bidProposal}
          projectName={projectName}
        />
      )}
    </>
  );
}

export default BidProposalDetailContainer;
